'use strict';

wbApp.factory('classroomSvc', ['$resource', '$q', 'repositorySvc', 'domainsSvc', 
    function ($resource, $q, repositorySvc, domainsSvc) {
        var Classroom = $resource('/Api/Classrooms/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/Classrooms/GetAll' },
            'update': { method: 'POST', url: '/Api/Classrooms/Update' },
            'insert': { method: 'POST', url: '/Api/Classrooms/Insert' },
            'delete': { method: 'POST', url: '/Api/Classrooms/Delete' },
            'domainsGetAll': { method: 'GET', isArray: true, url: '/restapi/places/:placeId/domains' },
            'domainsInsert': { method: 'POST', url: '/restapi/places/:placeId/domains' },
            'domainsUpdate': { method: 'PUT', url: '/restapi/places/:placeId/domains/:id' },
            'domainsDelete': { method: 'DELETE', url: '/restapi/places/:placeId/domains/:id' },
            'availabilityByDomainsAndRange': { method: 'POST', isArray: true, url: '/restapi/places/:placeId/availability/find-by-domains-and-range' }
        });

        var classrooms;
        var nonDeleted;

        function createNew() {
            return {
                id: 0,
                name: "",
                description: "",
                capacity: 0,
                active: true,
                isDeleted: false,
                addressID: null,
                showInCourses: true,
                showInReservations: true,
                reservationStartTimeType: 1,
                reservationsSchedulerScale: 30,
                reservationsSchedulerSelectByBlocks: 2,
                reservationsSchedulerMaximumSelectedBlocks: 4,
                address: {
                    addressID: 0,
                    addressJson: null,
                    formattedAddress: null,
                    location: { latitude: null, longitude: null },
                    mapZoom: null
                }
            };
        }

        function getAllAsync(reload) {
            if (!classrooms || reload) {
                classrooms = repositorySvc.customGet('getAll', Classroom);
                nonDeleted = null;
            }

            return classrooms;
        }

        function getAllNonDeletedAsync(reload) {
            if (nonDeleted && !reload) {
                return nonDeleted;
            }

            var allClassrooms = getAllAsync(reload);
            nonDeleted = [];
            var deferred = $q.defer();
            nonDeleted.$promise = deferred.promise;

            allClassrooms.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if (!value.isDeleted) {
                        nonDeleted.push(value);
                    }
                });
                deferred.resolve(nonDeleted);
            }, function (reason) {
                deferred.reject(reason);
            });

            return nonDeleted;
        }

        function getAllActiveAsync(classroomIDtoInclude, filterForReservations, filterForCourses, filterForRents) {
            var allClassrooms = getAllAsync();
            var filteredClassroom = [];

            var deferred = $q.defer();
            filteredClassroom.$promise = deferred.promise;

            allClassrooms.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if ((!value.isDeleted && value.active) || value.id === classroomIDtoInclude) {

                        if (!!filterForReservations && !!value.showInReservations) {
                            filteredClassroom.push(value);
                        }
                        else {
                            if (!!filterForCourses && !!value.showInCourses) {
                                filteredClassroom.push(value);
                            }
                            else {
                                if (!!filterForRents && !!value.showInRents) {
                                    filteredClassroom.push(value);
                                }
                            }
                        }
                    
                        if (!filterForReservations && !filterForCourses && !filterForRents) {
                            filteredClassroom.push(value);
                        }                        
                    }
                });
                deferred.resolve(filteredClassroom);
            }, function (reason) {
                deferred.reject(reason);
            });

            return filteredClassroom;
        }

        function get(id) {
            if (classrooms) {
                for (var i = 0; i < classrooms.length; i++) {
                    var sc = classrooms[i];
                    if (sc.id === id) {
                        return sc;
                    }
                }
            }
            return null;
        }

        function getAsync(id) {
            var cl = getAllAsync();

            var deferred = $q.defer();

            cl.$promise.then(function (data) {
                deferred.resolve(_.find(data, { id: id }));
            }, function(reason) {
                deferred.reject(reason);
            })

            return deferred.promise;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                Classroom,               // $resource
                classrooms,               // collection
                data,                     // entity
                success,
                errorCallback);

            function success(entity) {
                repositorySvc.entityInserted(nonDeleted, entity);

                if (successCallback) {
                    successCallback(entity);
                }
            }
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                Classroom,            // $resource
                classrooms,            // collection
                data,                  // entity
                success,
                errorCallback);

            function success(entity) {
                repositorySvc.entityUpdated(nonDeleted, entity);

                if (successCallback) {
                    successCallback(entity);
                }
            }
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                Classroom,              // $resource
                classrooms,              // collection
                data,                    // entity
                success,
                errorCallback);

            function success() {
                repositorySvc.entityRemoved(nonDeleted, data.id);

                if (successCallback) {
                    successCallback();
                }
            }
        }

        function getPlacesDomains(placeId) {
            if (!placeId) {
                return $q(function (resolve, reject) {
                    resolve([]);
                });
            } else {
                return repositorySvc.customGet(
                    'domainsGetAll',
                    Classroom,
                    {
                        placeId: placeId
                    });
            }
        }

        function loadDomainsData(placeId) {
            return $q(function (resolve, reject) {
                $q.all([
                   domainsSvc.getAllExpanded().$promise,
                   getPlacesDomains(placeId).$promise])
               .then(function (data) {
                   let domains = [];
                   let placesDomains = data[1];
                   
                   _.each(data[0], function(d0) {
                       d0.parentId = null;
                       let placesDomain = _.find(placesDomains, function(d) { return d.id === d0.id});
                       if (!!placesDomain && !!placesDomain.domainPrices) {
                           d0.reservationTeacherHourSingleRateOverride = placesDomain.domainPrices.reservationTeacherHourSingleRate;
                           d0.reservationTeacherHourSingleRateOverrideOrigin = placesDomain.domainPrices.reservationTeacherHourSingleRate;

                           d0.reservationTeacherHourGroupOneRateOverride = placesDomain.domainPrices.reservationTeacherHourGroupOneRate;
                           d0.reservationTeacherHourGroupOneRateOverrideOrigin = placesDomain.domainPrices.reservationTeacherHourGroupOneRate;

                           d0.reservationTeacherHourGroupTwoRateOverride = placesDomain.domainPrices.reservationTeacherHourGroupTwoRate;
                           d0.reservationTeacherHourGroupTwoRateOverrideOrigin = placesDomain.domainPrices.reservationTeacherHourGroupTwoRate;
                       }
                       domains.push(d0);
                       
                       _.each(d0.specializations, function(d1) {
                           d1.parentId = d0.id;
                           let placesSpecialization = !!placesDomain 
                               ? _.find(placesDomain.specializationsPrices || [], function(s) { return s.id === d1.id})
                               : null;
                           if (!!placesSpecialization) {
                               d1.reservationTeacherHourSingleRateOverride = placesSpecialization.reservationTeacherHourSingleRate;
                               d1.reservationTeacherHourSingleRateOverrideOrigin = placesSpecialization.reservationTeacherHourSingleRate;

                               d1.reservationTeacherHourGroupOneRateOverride = placesSpecialization.reservationTeacherHourGroupOneRate;
                               d1.reservationTeacherHourGroupOneRateOverrideOrigin = placesSpecialization.reservationTeacherHourGroupOneRate;

                               d1.reservationTeacherHourGroupTwoRateOverride = placesSpecialization.reservationTeacherHourGroupTwoRate;
                               d1.reservationTeacherHourGroupTwoRateOverrideOrigin = placesSpecialization.reservationTeacherHourGroupTwoRate;                               
                           }
                           domains.push(d1);
                       });
                       delete d0.specializations;
                   });
                   
                   //console.error(domains);

                   let selection = _.flatMapDeep(placesDomains, function (d) {
                       return [d.domainId, d.specializationIds];
                   });

                   resolve({ domains: domains, selection: selection });
               }, function (error) {
                   reject(error);
               });
            });
        }

        // domains are flattened
        function saveDomainsData(placeId, flattenedDomains, origSelection, newSelection, success, error) {

            let origSelectionDict = _.keyBy(origSelection, function (o) { return o; })
            let newSelectionDict = _.keyBy(newSelection, function (o) { return o; })

            let toInsert = [];
            let toUpdate = [];
            let toDelete = [];

            let promisses = [];

            // un-flatten
            let domainsDict = {};
            let flattenedDomainsCopy = _.cloneDeep(flattenedDomains);
            
            _.forEach(flattenedDomainsCopy, function(d) {
                if (!d.parentId) {
                    domainsDict[d.id] = d;
                    d.specializations = [];
                    delete d.parentId;
                }
            });

            _.forEach(flattenedDomainsCopy, function(d) {
                if (!!d.parentId) {
                    domainsDict[d.parentId].specializations.push(d);
                    delete d.parentId;
                }
            });
            
            let domains = _.values(domainsDict);
            
            //console.error(domains);
            
            _.forEach(domains, function (d) {

                let origPlaceDomain = {
                    id: null,
                    domainId: null,
                    domainPrices: null,
                    specializationIds: [],
                    specializationsPrices: []
                };

                let newPlaceDomain = {
                    id: null,
                    domainId: null,
                    domainPrices: null,
                    specializationIds: [],
                    specializationsPrices: []
                }

                _.forEach(d.specializations, function (s) {
                    if (_.has(origSelectionDict, s.id)) {
                        origPlaceDomain.specializationIds.push(s.id);
                        if (!_.isNil(s.reservationTeacherHourSingleRateOverrideOrigin) ||
                            !_.isNil(s.reservationTeacherHourGroupOneRateOverrideOrigin) ||
                            !_.isNil(s.reservationTeacherHourGroupTwoRateOverrideOrigin)) {
                            origPlaceDomain.specializationsPrices.push({
                                id: s.id,
                                reservationTeacherHourSingleRate: s.reservationTeacherHourSingleRateOverrideOrigin,
                                reservationTeacherHourGroupOneRate: s.reservationTeacherHourGroupOneRateOverrideOrigin,
                                reservationTeacherHourGroupTwoRate: s.reservationTeacherHourGroupTwoRateOverrideOrigin,
                            })
                        }                        
                    }

                    if (_.has(newSelectionDict, s.id)) {
                        newPlaceDomain.specializationIds.push(s.id);
                        if (!_.isNil(s.reservationTeacherHourSingleRateOverride) ||
                            !_.isNil(s.reservationTeacherHourGroupOneRateOverride) ||
                            !_.isNil(s.reservationTeacherHourGroupTwoRateOverride)) {
                            newPlaceDomain.specializationsPrices.push({
                                id: s.id,
                                reservationTeacherHourSingleRate: s.reservationTeacherHourSingleRateOverride,
                                reservationTeacherHourGroupOneRate: s.reservationTeacherHourGroupOneRateOverride,
                                reservationTeacherHourGroupTwoRate: s.reservationTeacherHourGroupTwoRateOverride,                                
                            })
                        }
                    }
                });

                if (origPlaceDomain.specializationIds.length || _.has(origSelectionDict, d.id)) {
                    origPlaceDomain.id = d.id;
                    origPlaceDomain.domainId = d.id;
                    if (!_.isNil(d.reservationTeacherHourSingleRateOverrideOrigin) ||
                        !_.isNil(d.reservationTeacherHourGroupOneRateOverrideOrigin) ||
                        !_.isNil(d.reservationTeacherHourGroupTwoRateOverrideOrigin)) {
                        origPlaceDomain.domainPrices = {
                            id: d.id,
                            reservationTeacherHourSingleRate: d.reservationTeacherHourSingleRateOverrideOrigin,
                            reservationTeacherHourGroupOneRate: d.reservationTeacherHourGroupOneRateOverrideOrigin,
                            reservationTeacherHourGroupTwoRate: d.reservationTeacherHourGroupTwoRateOverrideOrigin,
                        } 
                    }
                }

                if (newPlaceDomain.specializationIds.length || _.has(newSelectionDict, d.id)) {
                    newPlaceDomain.id = d.id;
                    newPlaceDomain.domainId = d.id;
                    if (!_.isNil(d.reservationTeacherHourSingleRateOverride) ||
                        !_.isNil(d.reservationTeacherHourGroupOneRateOverride) ||
                        !_.isNil(d.reservationTeacherHourGroupTwoRateOverride)) {
                        newPlaceDomain.domainPrices = {
                            id: d.id,
                            reservationTeacherHourSingleRate: d.reservationTeacherHourSingleRateOverride,
                            reservationTeacherHourGroupOneRate: d.reservationTeacherHourGroupOneRateOverride,
                            reservationTeacherHourGroupTwoRate: d.reservationTeacherHourGroupTwoRateOverride,
                        }
                    }                    
                }

                if (!!origPlaceDomain.id && !newPlaceDomain.id) {
                    toDelete.push(origPlaceDomain);
                }

                if (!origPlaceDomain.id && !!newPlaceDomain.id) {
                    toInsert.push(newPlaceDomain);
                }

                if (!!origPlaceDomain.id && !!newPlaceDomain.id) {
                    if (!_.isEqual(origPlaceDomain, newPlaceDomain)) {
                        toUpdate.push(newPlaceDomain);
                    }
                }
            });

            _.forEach(toInsert, function (o) {
                promisses.push(repositorySvc.customPutWithParams('domainsInsert', Classroom, { placeId: placeId }, o));
            });
            _.forEach(toUpdate, function (o) {
                promisses.push(repositorySvc.customPutWithParams('domainsUpdate', Classroom, { placeId: placeId, id: o.id }, o));
            });
            _.forEach(toDelete, function (o) {
                promisses.push(repositorySvc.customDelete('domainsDelete', Classroom, { placeId: placeId, id: o.id }));
            });

            if (promisses.length === 0) {
                success();
            } else {
                $q.all(promisses).then(function (data) {
                    success(data);
                }, function (e) {
                    error(e);
                });
            }
        }

        function availabilityByDomainsAndRange(placeId, domains, date)
        {
            var startOfWeek = moment(date).startOf('isoWeek');
            var endOfWeek = moment(date).endOf('isoWeek').startOf('day');

            return $q(function (resolve, reject) {

                var result = Classroom['availabilityByDomainsAndRange'](
                    {
                        placeId: placeId
                    }, {
                        start: startOfWeek.toDate(),
                        end: endOfWeek.toDate(),
                        domains: domains
                    });

                result.$promise.then(
                    function (data) {
                        var result = _.flatMap(data, function (d) { return d.periods; });
                        resolve(result);
                    },
                    function (error) {
                        reject(error);
                    }
                 );
            });
        }

        function getAllBrief() {
            return $q(function (resolve, reject) {
                getAllActiveAsync().$promise.then(
                    function (data) {
                        resolve(_.map(data, function (c) {
                            return {
                                id: c.id + "",
                                name: c.name
                            }
                        }));
                    },
                    function (error) {
                        reject(error);
                    })
            });
        }
        
        return {
            getAllAsync: getAllAsync,
            getAllActiveAsync: getAllActiveAsync,
            getAllNonDeletedAsync: getAllNonDeletedAsync,
            get: get,
            getAsync: getAsync,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew,
            loadDomainsData: loadDomainsData,
            saveDomainsData: saveDomainsData,
            availabilityByDomainsAndRange: availabilityByDomainsAndRange,
            getAllBrief: getAllBrief,
        }
    }]);